// extracted by mini-css-extract-plugin
export default {"loaderContainer":"loader_loaderContainer__OJRqA","loader":"loader_loader__qZv+U","up-down6":"loader_up-down6__95pry","text":"loader_text__9VWMB"};